const ACCESS_DENIED_PATTERNS = [
  'do not have access',
  'do not have permission',
  "don't have permission",
  'not authorized',
  'unauthorized',
  'forbidden',
  'access denied',
  'does not have permission',
];

export function isAccessDeniedError(message: string): boolean {
  const lower = message.toLowerCase();
  return ACCESS_DENIED_PATTERNS.some((pattern) => lower.includes(pattern));
}

export const ACCESS_REVOKED_MESSAGE =
  'You no longer have access to this workflow';
